import { TOfferCategory } from '@cian/chats-api';

import { mapMessage } from './mapMessage';
import { IOfferSchema } from '../repositories/chats/entities/offer/OfferSchema';
import { ISyncChatSchema } from '../repositories/chats/entities/synchronization/SyncChatSchema';
import { IChat } from '../types/chatList';
import { TOffer } from '../types/offer';

export const mapChat = (chat: ISyncChatSchema): IChat => {
  const { datetimeForSorting, ...chatProps } = chat;

  const updated = new Date(datetimeForSorting).getTime();

  return {
    ...chatProps,
    updated,
    offer: chat.offer ? mapOffer(chat.offer) : undefined,
    lastMessage: chat.lastMessage ? mapMessage(chat.lastMessage) : undefined,
  };
};

function mapOffer(offer: IOfferSchema): TOffer {
  return {
    ...offer,
    category: (offer.category || 'flatSale') as TOfferCategory,
    fullUrl: offer.fullUrl || '',
  };
}
